import { computed, effect, signal } from '@preact/signals'
import { Product } from 'apps/commerce/types.ts'
import { useCart } from 'apps/vtex/hooks/useCart.ts'
import { Address, SimulationOrderForm } from 'apps/vtex/utils/types.ts'

const { cart } = useCart()
const simulateResult = signal<SimulationOrderForm | null>(null)
const products = signal<Product[] | null>(null)
const postalCodeInfo = signal<Address | null>(null)
const orderedProducts = signal<Record<string, Product>>({})
const excludedCategories = signal<string[]>([])
const locale = computed(() => cart.value?.clientPreferencesData.locale || 'pt-BR')
const currency = computed(() => cart.value?.storePreferencesData.currencyCode || 'BRL')
const country = computed(() => cart.value?.storePreferencesData.countryCode || 'BRA')
const shippingPrice = signal<number | null>(null)

effect(() => {
    // Prefer the Shipping totalizer from the cart when present.
    // Don't overwrite an existing simulated shippingPrice with `null` when the
    // cart update doesn't include the Shipping totalizer (for example,
    // after applying a coupon the platform may return a cart without
    // a Shipping totalizer). In that case keep the last known shipping
    // price (usually set by ShippingSimulation). This prevents the
    // minicart from losing the delivery estimate when applying coupons.
    const cartShipping = cart.value?.totalizers.find((i) => i.id === 'Shipping')?.value

    if (typeof cartShipping === 'number') {
        shippingPrice.value = cartShipping
    }
    // else: do not change shippingPrice (keep simulated value)
})

export const CheckoutStore = {
    simulateResult,
    products,
    locale,
    currency,
    postalCodeInfo,
    country,
    shippingPrice,
    orderedProducts,
    excludedCategories,
}
